import script from "./ColumnReorder.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnReorder.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnReorder.vue?vue&type=style&index=0&id=0f0afd58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f0afd58"]])

export default __exports__